<template>
  <div class="perso">
    <ul class="timeline">
      <li class="timeline__item -active">
        <span class="timeline__label"> Arrière</span>
      </li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
      <li class="timeline__item"><span class="timeline__label"></span></li>
    </ul>

    <div class="infoPartagePrix_informations mobile">
      <a href=""
        ><svg
          class="informations_partage"
          width="22"
          height="24"
          viewBox="0 0 22 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.1834 2.23077C15.9864 2.23077 14.9941 3.21732 14.9941 4.46154C14.9941 4.85235 15.092 5.21774 15.2634 5.53512C15.2728 5.54936 15.2819 5.56392 15.2907 5.57879C15.3032 5.6 15.3149 5.62149 15.3257 5.64321C15.7146 6.27601 16.4058 6.69231 17.1834 6.69231C18.3804 6.69231 19.3728 5.70577 19.3728 4.46154C19.3728 3.21732 18.3804 2.23077 17.1834 2.23077ZM14.1714 7.40212C14.9313 8.19643 15.9972 8.69231 17.1834 8.69231C19.5093 8.69231 21.3728 6.78593 21.3728 4.46154C21.3728 2.13716 19.5093 0.230774 17.1834 0.230774C14.8576 0.230774 12.9941 2.13716 12.9941 4.46154C12.9941 4.88153 13.0549 5.28787 13.1683 5.67178L7.43794 9.05934C6.67813 8.26508 5.61221 7.76923 4.42603 7.76923C2.10019 7.76923 0.236679 9.67561 0.236679 12C0.236679 14.3244 2.10019 16.2308 4.42603 16.2308C5.61241 16.2308 6.67851 15.7347 7.43834 14.9402L13.1697 18.3234C13.0554 18.7087 12.9941 19.1167 12.9941 19.5384C12.9941 21.8628 14.8576 23.7692 17.1834 23.7692C19.5093 23.7692 21.3728 21.8628 21.3728 19.5384C21.3728 17.2141 19.5093 15.3077 17.1834 15.3077C15.999 15.3077 14.9345 15.8021 14.1749 16.5943L8.44126 13.2098C8.55459 12.826 8.61538 12.4198 8.61538 12C8.61538 11.58 8.55453 11.1736 8.44109 10.7897L14.1714 7.40212ZM6.28293 10.817C6.29392 10.8392 6.3058 10.8611 6.31858 10.8827C6.32763 10.898 6.33701 10.913 6.34673 10.9276C6.51772 11.2447 6.61538 11.6097 6.61538 12C6.61538 12.3903 6.51771 12.7553 6.3467 13.0724C6.33688 13.0872 6.32739 13.1024 6.31826 13.1178C6.30561 13.1393 6.29384 13.161 6.28296 13.1829C5.89389 13.815 5.20309 14.2308 4.42603 14.2308C3.22901 14.2308 2.23668 13.2442 2.23668 12C2.23668 10.7558 3.22901 9.76923 4.42603 9.76923C5.20307 9.76923 5.89386 10.1849 6.28293 10.817ZM14.9941 19.5384C14.9941 19.1704 15.0809 18.8249 15.2342 18.5208C15.2584 18.4892 15.2809 18.4558 15.3017 18.4206C15.3254 18.3805 15.346 18.3393 15.3635 18.2974C15.7585 17.6981 16.4304 17.3077 17.1834 17.3077C18.3804 17.3077 19.3728 18.2942 19.3728 19.5384C19.3728 20.7827 18.3804 21.7692 17.1834 21.7692C15.9864 21.7692 14.9941 20.7827 14.9941 19.5384Z"
            fill="#170D42"
          /></svg
      ></a>
      <p class="informations_prix">Prix : 90€</p>
    </div>

    <div class="jeVeuxDesChaussures canvas">
      <!-- Arrières de chaussures -->
      <img
        class="vue1 default blanc Arriere"
        src="@/assets/img/vue1/vue1-arriere_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 noir Arriere"
        src="@/assets/img/vue1/vue1-arriere_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 gris Arriere"
        src="@/assets/img/vue1/vue1-arriere_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Arriere"
        src="@/assets/img/vue1/vue1-arriere_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Arriere"
        src="@/assets/img/vue1/vue1-arriere_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Arriere"
        src="@/assets/img/vue1/vue1-arriere_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Arriere"
        src="@/assets/img/vue1/vue1-arriere_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Arriere"
        src="@/assets/img/vue1/vue1-arriere_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Arriere"
        src="@/assets/img/vue2/vue2-arriere_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Arriere"
        src="@/assets/img/vue2/vue2-arriere_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Arriere"
        src="@/assets/img/vue2/vue2-arriere_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Arriere"
        src="@/assets/img/vue2/vue2-arriere_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Arriere"
        src="@/assets/img/vue2/vue2-arriere_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Arriere"
        src="@/assets/img/vue2/vue2-arriere_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Arriere"
        src="@/assets/img/vue2/vue2-arriere_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Arriere"
        src="@/assets/img/vue2/vue2-arriere_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Corps arrières de chaussures -->
      <img
        class="vue1 default blanc Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_blanc.png"
        alt="Corps Arrière"
      />
      <img
        class="vue1 noir Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_noir.png"
        alt="Corps Arrière"
      />
      <img
        class="vue1 gris Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Corps_arriere"
        src="@/assets/img/vue1/vue1-corpsarr_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Corps_arriere"
        src="@/assets/img/vue2/vue2-corpsarr_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Corps avant de chaussures -->
      <img
        class="vue1 default blanc Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_blanc.png"
        alt="Corps avant"
      />
      <img
        class="vue1 gris Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_gris.png"
        alt="Corps avant"
      />
      <img
        class="vue1 noir Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Corps_avant"
        src="@/assets/img/vue1/vue1-corpsavant_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Corps_avant"
        src="@/assets/img/vue2/vue2-corpsavant_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Doublures de chaussures -->
      <img
        class="vue1 default blanc Doublure"
        src="@/assets/img/vue1/vue1-doublure_blanc.png"
        alt="Doublure"
      />
      <img
        class="vue1 noir Doublure"
        src="@/assets/img/vue1/vue1-doublure_noir.png"
        alt="Doublure"
      />
      <img
        class="vue1 gris Doublure"
        src="@/assets/img/vue1/vue1-doublure_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Doublure"
        src="@/assets/img/vue1/vue1-doublure_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Doublure"
        src="@/assets/img/vue1/vue1-doublure_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Doublure"
        src="@/assets/img/vue1/vue1-doublure_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Doublure"
        src="@/assets/img/vue1/vue1-doublure_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Doublure"
        src="@/assets/img/vue1/vue1-doublure_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Doublure"
        src="@/assets/img/vue2/vue2-doublure_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Doublure"
        src="@/assets/img/vue2/vue2-doublure_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Doublure"
        src="@/assets/img/vue2/vue2-doublure_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Doublure"
        src="@/assets/img/vue2/vue2-doublure_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Doublure"
        src="@/assets/img/vue2/vue2-doublure_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Doublure"
        src="@/assets/img/vue2/vue2-doublure_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Doublure"
        src="@/assets/img/vue2/vue2-doublure_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Doublure"
        src="@/assets/img/vue2/vue2-doublure_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Lacets de chaussures -->
      <img
        class="vue1 default blanc Lacet"
        src="@/assets/img/vue1/vue1-lacet_blanc.png"
        alt="Lacet"
      />
      <img
        class="vue1 noir Lacet"
        src="@/assets/img/vue1/vue1-lacet_noir.png"
        alt="Lacet"
      />
      <img
        class="vue1 gris Lacet"
        src="@/assets/img/vue1/vue1-lacet_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Lacet"
        src="@/assets/img/vue1/vue1-lacet_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Lacet"
        src="@/assets/img/vue1/vue1-lacet_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Lacet"
        src="@/assets/img/vue1/vue1-lacet_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Lacet"
        src="@/assets/img/vue1/vue1-lacet_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Lacet"
        src="@/assets/img/vue1/vue1-lacet_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Lacet"
        src="@/assets/img/vue2/vue2-lacet_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Lacet"
        src="@/assets/img/vue2/vue2-lacet_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Lacet"
        src="@/assets/img/vue2/vue2-lacet_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Lacet"
        src="@/assets/img/vue2/vue2-lacet_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Lacet"
        src="@/assets/img/vue2/vue2-lacet_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Lacet"
        src="@/assets/img/vue2/vue2-lacet_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Lacet"
        src="@/assets/img/vue2/vue2-lacet_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Lacet"
        src="@/assets/img/vue2/vue2-lacet_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- languettes de chaussures -->
      <img
        class="vue1 default blanc Languette"
        src="@/assets/img/vue1/vue1-languette_blanc.png"
        alt="Languette"
      />
      <img
        class="vue1 Languette noir"
        src="@/assets/img/vue1/vue1-languette_noir.png"
        alt="Languette"
      />
      <img
        class="vue1 gris Languette"
        src="@/assets/img/vue1/vue1-languette_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Languette"
        src="@/assets/img/vue1/vue1-languette_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Languette"
        src="@/assets/img/vue1/vue1-languette_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Languette"
        src="@/assets/img/vue1/vue1-languette_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Languette"
        src="@/assets/img/vue1/vue1-languette_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Languette"
        src="@/assets/img/vue1/vue1-languette_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Languette"
        src="@/assets/img/vue2/vue2-languette_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Languette"
        src="@/assets/img/vue2/vue2-languette_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Languette"
        src="@/assets/img/vue2/vue2-languette_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Languette"
        src="@/assets/img/vue2/vue2-languette_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Languette"
        src="@/assets/img/vue2/vue2-languette_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Languette"
        src="@/assets/img/vue2/vue2-languette_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Languette"
        src="@/assets/img/vue2/vue2-languette_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Languette"
        src="@/assets/img/vue2/vue2-languette_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Milieux de chaussures -->
      <img
        class="vue1 default blanc Milieu"
        src="@/assets/img/vue1/vue1-milieu_blanc.png"
        alt="Milieu"
      />
      <img
        class="vue1 noir Milieu"
        src="@/assets/img/vue1/vue1-milieu_noir.png"
        alt="Milieu"
      />
      <img
        class="vue1 gris Milieu"
        src="@/assets/img/vue1/vue1-milieu_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Milieu"
        src="@/assets/img/vue1/vue1-milieu_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Milieu"
        src="@/assets/img/vue1/vue1-milieu_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Milieu"
        src="@/assets/img/vue1/vue1-milieu_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Milieu"
        src="@/assets/img/vue1/vue1-milieu_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Milieu"
        src="@/assets/img/vue1/vue1-milieu_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Milieu"
        src="@/assets/img/vue2/vue2-milieu_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Milieu"
        src="@/assets/img/vue2/vue2-milieu_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Milieu"
        src="@/assets/img/vue2/vue2-milieu_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Milieu"
        src="@/assets/img/vue2/vue2-milieu_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Milieu"
        src="@/assets/img/vue2/vue2-milieu_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Milieu"
        src="@/assets/img/vue2/vue2-milieu_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Milieu"
        src="@/assets/img/vue2/vue2-milieu_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Milieu"
        src="@/assets/img/vue2/vue2-milieu_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Renforts de chaussures -->
      <img
        class="vue1 default blanc Renfort"
        src="@/assets/img/vue1/vue1-renfort_blanc.png"
        alt="Renfort"
      />
      <img
        class="vue1 noir Renfort"
        src="@/assets/img/vue1/vue1-renfort_noir.png"
        alt="Renfort"
      />
      <img
        class="vue1 gris Renfort"
        src="@/assets/img/vue1/vue1-renfort_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Renfort"
        src="@/assets/img/vue1/vue1-renfort_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Renfort"
        src="@/assets/img/vue1/vue1-renfort_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Renfort"
        src="@/assets/img/vue1/vue1-renfort_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Renfort"
        src="@/assets/img/vue1/vue1-renfort_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Renfort"
        src="@/assets/img/vue1/vue1-renfort_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Renfort"
        src="@/assets/img/vue2/vue2-renfort_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Renfort"
        src="@/assets/img/vue2/vue2-renfort_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Renfort"
        src="@/assets/img/vue2/vue2-renfort_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Renfort"
        src="@/assets/img/vue2/vue2-renfort_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Renfort"
        src="@/assets/img/vue2/vue2-renfort_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Renfort"
        src="@/assets/img/vue2/vue2-renfort_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Renfort"
        src="@/assets/img/vue2/vue2-renfort_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Renfort"
        src="@/assets/img/vue2/vue2-renfort_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Semelles de chaussures -->
      <img
        class="vue1 default blanc Semelle"
        src="@/assets/img/vue1/vue1-semelle_blanc.png"
        alt="Semelle"
      />
      <img
        class="vue1 noir Semelle"
        src="@/assets/img/vue1/vue1-semelle_noir.png"
        alt="Semelle"
      />
      <img
        class="vue1 gris Semelle"
        src="@/assets/img/vue1/vue1-semelle_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Semelle"
        src="@/assets/img/vue1/vue1-semelle_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Semelle"
        src="@/assets/img/vue1/vue1-semelle_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Semelle"
        src="@/assets/img/vue1/vue1-semelle_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Semelle"
        src="@/assets/img/vue1/vue1-semelle_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Semelle"
        src="@/assets/img/vue1/vue1-semelle_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Semelle"
        src="@/assets/img/vue2/vue2-semelle_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Semelle"
        src="@/assets/img/vue2/vue2-semelle_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Semelle"
        src="@/assets/img/vue2/vue2-semelle_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Semelle"
        src="@/assets/img/vue2/vue2-semelle_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Semelle"
        src="@/assets/img/vue2/vue2-semelle_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Semelle"
        src="@/assets/img/vue2/vue2-semelle_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Semelle"
        src="@/assets/img/vue2/vue2-semelle_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Semelle"
        src="@/assets/img/vue2/vue2-semelle_bleu.png"
        alt="Arrière de la chaussure"
      />

      <!-- Toeboxes de chaussures -->
      <img
        class="vue1 default blanc Toe_box"
        src="@/assets/img/vue1/vue1-toebox_blanc.png"
        alt="Toe Box"
      />
      <img
        class="vue1 noir Toe_box"
        src="@/assets/img/vue1/vue1-toebox_noir.png"
        alt="Toe Box"
      />
      <img
        class="vue1 gris Toe_box"
        src="@/assets/img/vue1/vue1-toebox_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rouge Toe_box"
        src="@/assets/img/vue1/vue1-toebox_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 vert Toe_box"
        src="@/assets/img/vue1/vue1-toebox_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 lavande Toe_box"
        src="@/assets/img/vue1/vue1-toebox_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 rose Toe_box"
        src="@/assets/img/vue1/vue1-toebox_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue1 bleu Toe_box"
        src="@/assets/img/vue1/vue1-toebox_bleu.png"
        alt="Arrière de la chaussure"
      />
      <!-- Vue2 -->
      <img
        class="vue2 blanc Toe_box"
        src="@/assets/img/vue2/vue2-toebox_blanc.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 noir Toe_box"
        src="@/assets/img/vue2/vue2-toebox_noir.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 gris Toe_box"
        src="@/assets/img/vue2/vue2-toebox_gris.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rouge Toe_box"
        src="@/assets/img/vue2/vue2-toebox_rouge.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 vert Toe_box"
        src="@/assets/img/vue2/vue2-toebox_vert.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 lavande Toe_box"
        src="@/assets/img/vue2/vue2-toebox_lavande.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 rose Toe_box"
        src="@/assets/img/vue2/vue2-toebox_rose.png"
        alt="Arrière de la chaussure"
      />
      <img
        class="vue2 bleu Toe_box"
        src="@/assets/img/vue2/vue2-toebox_bleu.png"
        alt="Arrière de la chaussure"
      />
    </div>

    <div class="changeEtapes mobile">
        <div id="vue1" class="BtnVue interactif actif" @click="viewPicked('vue1')">
          <p>Vue de côté</p>
        </div>
        <div id="vue2" class="BtnVue interactif" @click="viewPicked('vue2')">
          <p>Vue de dessus</p>
        </div>
      </div>

    <div class="infoPartagePrix">
      <div class="bulle interactif" href="#inspiPerso">
        <div class="infoPartagePrix_inspiration">
          <p class="inspiration_texte desktop">Besoin d'inspiration ?</p>
          <svg
            class="mobile"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9941 22H14.9941H10.9941ZM5.99414 9C5.99414 7.14348 6.73164 5.36301 8.04439 4.05025C9.35715 2.7375 11.1376 2 12.9941 2C14.8507 2 16.6311 2.7375 17.9439 4.05025C19.2566 5.36301 19.9941 7.14348 19.9941 9C19.9948 10.1271 19.7222 11.2375 19.1997 12.2362C18.6772 13.2348 17.9204 14.0919 16.9941 14.734L16.4521 17.3C16.3804 17.773 16.1415 18.2046 15.7788 18.5165C15.416 18.8284 14.9535 18.9999 14.4751 19H11.5131C11.0348 18.9999 10.5723 18.8284 10.2095 18.5165C9.84681 18.2046 9.6079 17.773 9.53614 17.3L8.99414 14.745C8.06755 14.1006 7.31071 13.2415 6.78829 12.2411C6.26587 11.2407 5.9934 10.1286 5.99414 9V9Z"
              stroke="#FAF8FF"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.99414 15H16.9941"
              stroke="#FAF8FF"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <button @click="saveShoeHandler()" class="primaryBtn -fleche interactif mobile">
        <span>Termine</span>
        <span class="icon-container"
          ><svg
            class="fleche"
            version="1.1"
            id="Calque_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 42 16.1"
            enable-background="new 0 0 42 16.1"
            xml:space="preserve"
          >
            <path
              class="fleche__line"
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="#170D42"
              d="M24.4,7.1H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h19.4"
            />
            <path
              class="fleche__pointe"
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="#170D42"
              d="M24.4,9.1l-5.9,5.3c-0.4,0.4-0.4,1-0.1,1.4s1,0.4,1.4,0.1l7.8-7
                       c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.6-0.3-0.7l-7.8-7.2c-0.4-0.4-1-0.3-1.4,0.1s-0.3,1,0.1,1.4l5.9,5.3"
            />
          </svg>
        </span>
      </button>

      <div class="changeEtapes desktop">
        <div id="vue1" class="BtnVue interactif actif" @click="viewPicked('vue1')">
          <p>Vue de côté</p>
        </div>
        <div id="vue2" class="BtnVue interactif" @click="viewPicked('vue2')">
          <p>Vue de dessus</p>
        </div>
      </div>

      <div class="infoPartagePrix_informations desktop">
        <a href=""
          ><svg
            class="informations_partage"
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.1834 2.23077C15.9864 2.23077 14.9941 3.21732 14.9941 4.46154C14.9941 4.85235 15.092 5.21774 15.2634 5.53512C15.2728 5.54936 15.2819 5.56392 15.2907 5.57879C15.3032 5.6 15.3149 5.62149 15.3257 5.64321C15.7146 6.27601 16.4058 6.69231 17.1834 6.69231C18.3804 6.69231 19.3728 5.70577 19.3728 4.46154C19.3728 3.21732 18.3804 2.23077 17.1834 2.23077ZM14.1714 7.40212C14.9313 8.19643 15.9972 8.69231 17.1834 8.69231C19.5093 8.69231 21.3728 6.78593 21.3728 4.46154C21.3728 2.13716 19.5093 0.230774 17.1834 0.230774C14.8576 0.230774 12.9941 2.13716 12.9941 4.46154C12.9941 4.88153 13.0549 5.28787 13.1683 5.67178L7.43794 9.05934C6.67813 8.26508 5.61221 7.76923 4.42603 7.76923C2.10019 7.76923 0.236679 9.67561 0.236679 12C0.236679 14.3244 2.10019 16.2308 4.42603 16.2308C5.61241 16.2308 6.67851 15.7347 7.43834 14.9402L13.1697 18.3234C13.0554 18.7087 12.9941 19.1167 12.9941 19.5384C12.9941 21.8628 14.8576 23.7692 17.1834 23.7692C19.5093 23.7692 21.3728 21.8628 21.3728 19.5384C21.3728 17.2141 19.5093 15.3077 17.1834 15.3077C15.999 15.3077 14.9345 15.8021 14.1749 16.5943L8.44126 13.2098C8.55459 12.826 8.61538 12.4198 8.61538 12C8.61538 11.58 8.55453 11.1736 8.44109 10.7897L14.1714 7.40212ZM6.28293 10.817C6.29392 10.8392 6.3058 10.8611 6.31858 10.8827C6.32763 10.898 6.33701 10.913 6.34673 10.9276C6.51772 11.2447 6.61538 11.6097 6.61538 12C6.61538 12.3903 6.51771 12.7553 6.3467 13.0724C6.33688 13.0872 6.32739 13.1024 6.31826 13.1178C6.30561 13.1393 6.29384 13.161 6.28296 13.1829C5.89389 13.815 5.20309 14.2308 4.42603 14.2308C3.22901 14.2308 2.23668 13.2442 2.23668 12C2.23668 10.7558 3.22901 9.76923 4.42603 9.76923C5.20307 9.76923 5.89386 10.1849 6.28293 10.817ZM14.9941 19.5384C14.9941 19.1704 15.0809 18.8249 15.2342 18.5208C15.2584 18.4892 15.2809 18.4558 15.3017 18.4206C15.3254 18.3805 15.346 18.3393 15.3635 18.2974C15.7585 17.6981 16.4304 17.3077 17.1834 17.3077C18.3804 17.3077 19.3728 18.2942 19.3728 19.5384C19.3728 20.7827 18.3804 21.7692 17.1834 21.7692C15.9864 21.7692 14.9941 20.7827 14.9941 19.5384Z"
              fill="#170D42"
            /></svg
        ></a>
        <p class="informations_prix">Prix : 90€</p>
      </div>
    </div>

    <div class="perso__layer2">
      <span class="perso__menu">
        <div class="interactif">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 1H2C1.44772 1 1 1.44772 1 2V8C1 8.55229 1.44772 9 2 9H8C8.55229 9 9 8.55229 9 8V2C9 1.44772 8.55229 1 8 1ZM2 0C0.895431 0 0 0.89543 0 2V8C0 9.10457 0.89543 10 2 10H8C9.10457 10 10 9.10457 10 8V2C10 0.895431 9.10457 0 8 0H2Z"
              fill="#170D42"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20 1H14C13.4477 1 13 1.44772 13 2V8C13 8.55229 13.4477 9 14 9H20C20.5523 9 21 8.55229 21 8V2C21 1.44772 20.5523 1 20 1ZM14 0C12.8954 0 12 0.89543 12 2V8C12 9.10457 12.8954 10 14 10H20C21.1046 10 22 9.10457 22 8V2C22 0.895431 21.1046 0 20 0H14Z"
              fill="#170D42"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20 13H14C13.4477 13 13 13.4477 13 14V20C13 20.5523 13.4477 21 14 21H20C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13ZM14 12C12.8954 12 12 12.8954 12 14V20C12 21.1046 12.8954 22 14 22H20C21.1046 22 22 21.1046 22 20V14C22 12.8954 21.1046 12 20 12H14Z"
              fill="#170D42"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 13H2C1.44772 13 1 13.4477 1 14V20C1 20.5523 1.44772 21 2 21H8C8.55229 21 9 20.5523 9 20V14C9 13.4477 8.55229 13 8 13ZM2 12C0.895431 12 0 12.8954 0 14V20C0 21.1046 0.89543 22 2 22H8C9.10457 22 10 21.1046 10 20V14C10 12.8954 9.10457 12 8 12H2Z"
              fill="#170D42"
            />
          </svg>
        </div>

        <div class="ChoixPerso">
          <h1 class="nom-etape" id="Nom_etape">Arrière</h1>

          <div class="etapesFleches">
            <h3 class="num-etape" id="Num_etape">1/10</h3>

            <div class="fleche-perso interactif" id="previous">
              <svg
                width="24"
                height="16"
                viewBox="0 0 24 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="stepPicked('previous')"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.13885 15.7445C8.55003 16.1132 9.18226 16.0788 9.55097 15.6676C9.91968 15.2564 9.88524 14.6242 9.47406 14.2555L3.6131 8.99999L23 8.99999C23.5523 8.99999 24 8.55228 24 7.99999C24 7.44771 23.5523 6.99999 23 6.99999L3.6131 6.99999L9.47406 1.74451C9.88524 1.3758 9.91968 0.743571 9.55097 0.332386C9.18226 -0.0787996 8.55003 -0.113235 8.13885 0.255473L0.332396 7.25547C0.120862 7.44515 7.24222e-07 7.71586 6.99383e-07 7.99999C6.74544e-07 8.28411 0.120862 8.55482 0.332396 8.74451L8.13885 15.7445Z"
                  fill="#170D42"
                />
              </svg>
            </div>
            <div class="fleche-perso interactif" id="next">
              <svg
                width="24"
                height="16"
                viewBox="0 0 24 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="stepPicked('next')"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.8612 0.255483C15.45 -0.113224 14.8177 -0.078789 14.449 0.332396C14.0803 0.743581 14.1148 1.37581 14.5259 1.74452L20.3869 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H20.3869L14.5259 14.2555C14.1148 14.6242 14.0803 15.2564 14.449 15.6676C14.8177 16.0788 15.45 16.1132 15.8612 15.7445L23.6676 8.74452C23.8791 8.55483 24 8.28412 24 8C24 7.71588 23.8791 7.44517 23.6676 7.25548L15.8612 0.255483Z"
                  fill="#170D42"
                />
              </svg>
            </div>
          </div>
        </div>
      </span>
      <span class="perso__layer2-milieu">
        <span class="menu-choix-custo">
          <a class="choix-custo interactif" href="">
            <img src="@/assets/Icones/couleurs.svg" alt="" />
            <h3>Couleurs</h3>
          </a>
          <a class="choix-custo interactif" href="">
            <img src="@/assets/Icones/collab.svg" alt="" />
            <h3>Collaborations</h3>
          </a>
        </span>
      </span>

      <span class="perso__btn-terminer">
        <div class="perso_reset interactif" @click="reset()">
          <img src="@/assets/Icones/reset.svg" alt="" />
        </div>

        <button
          @click="saveShoeHandler()"
          class="primaryBtn -fleche interactif desktop"
        >
          <span>
            Termine
          </span>
          <span class="icon-container"
            ><svg
              class="fleche"
              version="1.1"
              id="Calque_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 42 16.1"
              enable-background="new 0 0 42 16.1"
              xml:space="preserve"
            >
              <path
                class="fleche__line"
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#170D42"
                d="M24.4,7.1H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h19.4"
              />
              <path
                class="fleche__pointe"
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#170D42"
                d="M24.4,9.1l-5.9,5.3c-0.4,0.4-0.4,1-0.1,1.4s1,0.4,1.4,0.1l7.8-7
                       c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.6-0.3-0.7l-7.8-7.2c-0.4-0.4-1-0.3-1.4,0.1s-0.3,1,0.1,1.4l5.9,5.3"
              />
            </svg>
          </span>
        </button>
      </span>
    </div>

    <div class="perso__choix">
      <div
        v-for="(label, index) in colors"
        :key="index"
        class="choix__col interactif"
        @click="colorPicked($event, label)"
      >
        <div :class="`col__img${index + 1}`"></div>
        <p class="col__txt">{{ label }}</p>
      </div>
    </div>

    <div id="inspiPerso">
      <div class="inspiPerso_texte">
        <h2 class="inspiPerso_titre">Besoin d'inspiration ?</h2>
        <p class="inspiPerso_paragraphe">
          Besoin d'inspiration pour faire ta customisation ? Penses à regarder
          les modèles réalisés par les créatifs. N'hésites pas à y partager ta
          propre création.
        </p>
        <a class="inspiPerso_btn primaryBtn -fleche" href="./galerie.html">
          <span>Accède à la galerie</span>
          <span class="icon-container"
            ><svg
              class="fleche"
              version="1.1"
              id="Calque_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 42 16.1"
              enable-background="new 0 0 42 16.1"
              xml:space="preserve"
            >
              <path
                class="fleche__line"
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#170D42"
                d="M24.4,7.1H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h19.4"
              />
              <path
                class="fleche__pointe"
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#170D42"
                d="M24.4,9.1l-5.9,5.3c-0.4,0.4-0.4,1-0.1,1.4s1,0.4,1.4,0.1l7.8-7 c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.6-0.3-0.7l-7.8-7.2c-0.4-0.4-1-0.3-1.4,0.1s-0.3,1,0.1,1.4l5.9,5.3"
              /></svg
          ></span>
        </a>
      </div>
      <img
        class="inspiPerso_image"
        src="@/assets/img/img_inspiration.svg"
        alt="image d'inspiration"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import domtoimage from "dom-to-image-more";

export default {
  data() {
    return {
      options: {
        element: "Arriere",
        color: null,
        view: "vue1",
        index: 0,
        indexView: 0,
        test: 0,
      },
      choix: {
        Arriere: "blanc",
        Corps_arriere: "blanc",
        Corps_avant: "blanc",
        Doublure: "blanc",
        Lacet: "blanc",
        Languette: "blanc",
        Milieu: "blanc",
        Renfort: "blanc",
        Semelle: "blanc",
        Toe_box: "blanc",
      },
      colors: [
        "Blanc",
        "Noir",
        "Gris",
        "Rouge",
        "Vert",
        "Lavande",
        "Rose",
        "Bleu",
      ],
      elements: [
        "Arriere",
        "Corps_arriere",
        "Corps_avant",
        "Doublure",
        "Lacet",
        "Languette",
        "Milieu",
        "Renfort",
        "Semelle",
        "Toe_box",
      ],
      views: ["vue1", "vue2"],
      names: [
        "Arrière",
        "Corps arrière",
        "Corps avant",
        "Doublure",
        "Lacet",
        "Languette",
        "Milieu",
        "Renfort",
        "Semelle",
        "Toe box",
      ],
    };
  },
  computed: {
    colorActive: function () {
      return this.options.color;
    },
    stepActive: function () {
      return this.options.element;
    },
    viewActive: function () {
      return this.options.view;
    },
  },
  mounted() {
    this.canvas = document.querySelector(".canvas");
    this.header = document.querySelector("#header");
    this.header.classList.add("header__perso")
  },
  methods: {
    saveShoeHandler() {
      this.getScreenShot(this.sendImageToWPMediaLibrary)
    },
    getScreenShot(callback) {
      domtoimage
        .toBlob(document.querySelector('.canvas'))
        .then( (image) => {
          callback(image)
        })
    },
    sendImageToWPMediaLibrary(image) {
      axios.post("https://agemovue.sebastienjourdain.com/wp-json/wp/v2/media", image, 
        {
          headers: {
            'Content-Disposition': `attachment; filename="${this.$store.state.user.displayName}.jpg`,
            'Authorization': `Bearer ${this.$store.state.user.authToken}`,
          }
        })
        .then(response => {
          if (response.data.id) {
            this.createShoe(response.data.source_url)
          }
        })
    },
    createShoe(imageURL) {

            axios.post('https://agemovue.sebastienjourdain.com/wp-json/wp/v2/shoes',
            {
                "status": "publish",
                "title": this.$store.state.user.displayName,
                'fields': {
                    'image_url': imageURL
                }
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.$store.state.user.authToken}`
                }
            })
            .then(response => {
                console.log('SHOE IS CREATED', response)
                this.shoeCreated = true
                this.$router.push('Panier')
            })
    },
    viewPicked(view) {
      let btnActif = document.querySelectorAll(".BtnVue")
      console.log(btnActif)

      btnActif.forEach((item) => {
        if(item.classList.contains("actif") === true && item.id !== view) {
            item.classList.remove("actif")
        }
        else if (item.id === view) {
          item.classList.add("actif")
        }
      })

      this.canvas.querySelectorAll(`.${this.options.view}`).forEach( (item) => {
        item.classList.remove("show")
        if (item.classList.contains("default") === true){
          item.classList.remove("default")
        }
      })

      this.canvas.querySelectorAll("." + view + ".blanc").forEach( (item) => {
          item.classList.add("default")
      })

      this.options.view = view

      for (const property in this.choix) {
        this.canvas.querySelector(`.${property}.${this.choix[property]}` + "." + view).classList.add("show")
      }

    },
    stepPicked(stepSelection) {
      let stepNom = document.querySelector("#Nom_etape");
      let stepNum = document.querySelector("#Num_etape");
      let timeline_label = document.querySelectorAll(".timeline__label");
      let timeline_item = document.querySelectorAll(".timeline__item");

      timeline_item[this.options.indexView].classList.remove("-active");
      timeline_label[this.options.indexView].innerHTML = "";

      if (this.options.indexView <= 0 || this.options.indexView >= 9) {
        if (this.options.indexView === 0 && stepSelection === "previous") {
          this.options.indexView = 0;
        } else if (this.options.indexView === 0 && stepSelection === "next") {
          this.options.indexView++;
        }
        if (this.options.indexView === 9 && stepSelection === "next") {
          this.options.indexView = 9;
        } else if (
          this.options.indexView === 9 &&
          stepSelection === "previous"
        ) {
          this.options.indexView--;
        }
      } else {
        if (stepSelection === "next") {
          this.options.indexView++;
        } else {
          this.options.indexView--;
        }
      }

      console.log(this.options.view);

      stepNom.innerHTML = this.names[this.options.indexView];
      timeline_label[this.options.indexView].innerHTML = this.names[this.options.indexView];
      stepNum.innerHTML = this.options.indexView + 1 + "/10";
      timeline_item[this.options.indexView].classList.add("-active");
      this.options.element = this.elements[this.options.indexView];
    },
    colorPicked(event, label) {
      this.options.color = label.toLowerCase();

      this.canvas
        .querySelectorAll(`.${this.options.view}.${this.options.element}`)
        .forEach((item) => {
          item.classList.remove("show");
        });

      this.canvas
        .querySelector(
          `.${this.options.view}.${this.options.element}.${this.options.color}`
        )
        .classList.add("show");

      // Sauvegarder les choix de couleur par elements dans un object choix, réutiliser cet object pour les différentes vue de chaussure
      // Check le log
      this.choix[this.options.element] = this.options.color;
      console.log(this.choix);
    },
    reset() {
      this.canvas.querySelectorAll("img" + `.${this.options.view}`).forEach((item) => {
        if (item.classList.contains("default") === false) {
          item.classList.remove("show");
        }
        if (item.classList.contains("blanc") === true) {
          item.classList.add("default");
        }
        for (var member in this.choix) delete this.choix[member];
      });
    },
  },
};
</script>

<style lang="scss">
.header__perso {
    display: flex;
    align-items: center;
    position: inherit;
    width: inherit;
    background: initial;
    height: initial;
}

.col__img1 {
  background: #f1e8e8;
  box-shadow: 0vh 0vh 1vh rgba(0, 0, 0, 0.25);
}

.col__img2 {
  background-color: #000000;
}

.col__img3 {
  background: #535356;
}

.col__img4 {
  background: #782020;
}

.col__img5 {
  background: #275f37;
}

.col__img6 {
  background-color: #b494e8;
}

.col__img7 {
  background-color: #ffcdfe;
}

.col__img8 {
  background-color: #5a8cd8;
}

//Début des styles de la Perso//

.canvas {
  img {
    display: none;
  }

  img.show {
    display: block;
  }

  .default {
    display: block;
  }
}

.interactif {
  cursor: pointer;
}

.actif {
  background-color: #6970FF;
}

.actif p {
  color: white;
}

@media screen and (min-width: 960px) {
  // MEDIA QUERIES DESKTOP //
  .timeline {
    list-style: none;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::after {
      content: "";
      width: 95%;
      margin-left: 2%;
      border-top: 1px solid black;
      display: block;
      position: absolute;
      top: math.div($size, 2) + px;
      z-index: -9999;
    }
    &__item {
      &::before {
        content: "";
        width: $size + px;
        height: $size + px;
        display: block;
        margin: 0 auto 0.5rem;
        background-color: white;
        background-image: url(../assets/Icones/eclipse.svg);
        background-repeat: no-repeat;
        background-position: center;
      }
      span {
        opacity: 0;
      }
      &.-active {
        &::before {
          background-image: url(../assets/Icones/Etoile.svg);
        }
        span {
          opacity: 1;
        }
      }
    }
  }

  /* fin des styles timeline*/

  /*styles perso*/

  .perso__menu {
    display: flex;
    margin-left: 10%;
    margin-top: 5%;
    line-height: 3vh;
    grid-column: 1;
  }

  .nom-etape {
    margin-left: 5%;
    white-space: nowrap;
  }

  .num-etape {
    margin-left: 7%;
  }

  .fleche-perso {
    margin-left: 7%;
  }

  .choix-custo {
    display: flex;
    text-decoration: none;
    justify-content: center;
    width: 25%;
    align-items: center;
    // margin-left: 10%;
  }

  .choix-custo h3 {
    margin-left: 10%;
  }

  .menu-choix-custo {
    display: flex;
    align-items: center;
    margin-top: 1.5%;
    justify-content: center;
    margin-left: 10%;
  }

  .perso__btn-terminer a {
    margin-left: 1%;
  }

  .perso__btn-terminer {
    justify-content: center;
    display: flex;
    margin-left: 16%;
  }

  .perso__layer2 {
    display: grid;
    grid-template-columns: repeat(3);
    grid-auto-columns: 20% 60% 20%;
  }

  .perso__layer2-milieu {
    grid-column: 2;
    display: none;
  }

  .perso__btn-terminer {
    grid-column: 3;
  }

  .perso__btn-terminer a {
    margin-left: 2%;
  }

  .perso_reset {
    margin-top: 5%;
    margin-right: 10%;
    width: 7%;
  }
  .timeline {
    width: 70%;
    margin: auto;
    display: flex;
    align-items: flex-start;
    hr {
      width: 63%;
      position: absolute;
      margin: 0.62% 0 0 4%;
      border: 1px solid black;
      background-color: black;
      z-index: -1;
    }
  }

  .timeline__point {
    margin: auto;
    margin-top: 0;
    img {
      border-left: 4px solid white;
      border-right: 4px solid white;
      border-radius: 50%;
      background-color: white;
    }
  }

  .-inactif {
    margin-top: 0.4%;
  }

  .-actif img {
    margin-left: 20%;
    margin-top: 1%;
  }
  /* partie infoPartagePrix */
  .infoPartagePrix {
    display: flex;
    justify-content: space-between;
    margin: 2vw;
    margin-top: 5vw;
  }

  .infoPartagePrix_informations {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 12vw;
  }

  .informations_prix {
    font-size: 1.25vw;
    font-weight: 700;
    color: $colorTitle;
  }

  .inspiration_texte {
    font-weight: 500;
    color: white;
    text-align: center;
    margin: auto;
  }

  /*test bulle */
  .infoPartagePrix_inspiration {
    background: $bleuVert;
    border-radius: 1.2vw;
    border-bottom-left-radius: initial;
    width: 120%;
    height: 5vh;
    display: flex;
  }

  /* partie inspiration */
  #inspiPerso {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 10%;
  }

  .bulle {
    text-decoration: none;
  }

  .inspiPerso_texte {
    flex-direction: column;
    width: 17vw;
  }

  .inspiPerso_paragraphe {
    margin-bottom: 10%;
    margin-top: 5%;
  }

  .inspiPerso_btn {
    margin-top: 2%;
    padding: 1rem 0.925rem 1rem 1.8rem;
    transition: width 0.5s ease-in-out;
  }

  .inspiPerso_btn:hover {
    transition: width 0.5s ease-in-out;
    width: 100%;
  }

  .inspiPerso_image {
    width: 40%;
  }

  .perso__choix {
    display: flex;
    justify-content: center;
    margin-left: 10%;
  }

  .perso__choix a {
    text-decoration: none;
  }

  .choix__col {
    margin-right: 3%;
  }

  .col__img1,
  .col__img2,
  .col__img3,
  .col__img4,
  .col__img5,
  .col__img6,
  .col__img7,
  .col__img8 {
    width: 5vh;
    height: 5vh;
    border-radius: 100%;
    margin: auto;
  }

  .col__txt {
    font-weight: 200;
    text-align: center;
    margin-top: 10%;
    font-size: 14px;
  }

  .etapesFleches {
    margin-top: 10%;
    display: flex;
  }

  .ChoixPerso {
    width: 100%;
  }

  .changeEtapes {
    display: flex;
    align-items: center;
    width: 20%;
    justify-content: space-between;
    margin-left: 10%;
    & .BtnVue {
      padding: 4%;
      border: $bleuVert solid 0.2px;
      border-radius: 10px;
      &:hover {
        background-color: $bleuVert;
        p {
          color: white;
        }
      }
    }
  }

  .jeVeuxDesChaussures {
    display: flex;
    width: 100%;
    height: 40vh;
    position: relative;
  }

  .jeVeuxDesChaussures img {
    position: absolute;
    width: 50%;
    left: 25%;
  }
}

@media screen and (max-width: 960px) {
  // MEDIA QUERIES MOBILE //
  .timeline {
    display: none !important;
  }

  .jeVeuxDesChaussures {
    display: flex;
    width: 100%;
    height: 25vh;
    position: relative;
    margin-bottom: 5%;
  }

  .jeVeuxDesChaussures img {
    position: absolute;
    width: 90%;
    left: 5%;
  }

  /*styles perso*/

  .perso__menu {
    display: flex;
    margin-left: 10%;
    margin-top: 5%;
    line-height: 3vh;
    grid-column: 1;
  }

  .nom-etape {
    margin-left: 5%;
    white-space: nowrap;
  }

  .num-etape {
    margin-left: 7%;
  }

  .fleche-perso {
    margin-left: 7%;
  }

  .choix-custo {
    display: flex;
    text-decoration: none;
    justify-content: center;
    width: 25%;
    align-items: center;
    // margin-left: 10%;
  }

  .choix-custo h3 {
    margin-left: 10%;
  }

  .menu-choix-custo {
    display: flex;
    align-items: center;
    margin-top: 1.5%;
    justify-content: center;
    margin-left: 10%;
  }

  .perso__btn-terminer a {
    margin-left: 1%;
  }

  .perso__btn-terminer {
    justify-content: center;
    display: flex;
    align-items: center;
  }

  .perso__layer2 {
    display: grid;
    grid-template-columns: repeat(3);
    grid-auto-columns: 65% 15% 20%;
    margin-bottom: 10%;
    margin-top: 5%;
  }

  .perso__layer2-milieu {
    grid-column: 2;
    display: none;
  }

  .perso__btn-terminer {
    grid-column: 3;
  }

  .perso_reset {
    margin-top: 5%;
    margin-right: 10%;
    width: 7%;
  }

  .-inactif {
    margin-top: 0.4%;
  }

  .-actif img {
    margin-left: 20%;
    margin-top: 1%;
  }
  /* partie infoPartagePrix */
  .infoPartagePrix {
    display: flex;
    justify-content: space-between;
    margin: 2vmax;
  }

  .infoPartagePrix_informations {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 5%;
    width: 90%;
    margin-bottom: 15%;
    margin-top: 10%;
  }

  .informations_prix {
    font-weight: 700;
    color: $colorTitle;
  }

  .inspiration_texte {
    font-weight: 500;
    color: white;
    text-align: center;
    margin: auto;
  }

  /*test bulle */
  .infoPartagePrix_inspiration {
    background: $bleuVert;
    border-radius: 15px;
    border-bottom-left-radius: initial;
    width: fit-content;
    padding: 35%;
    height: 5vh;
    display: flex;
  }

  /* partie inspiration */
  #inspiPerso {
    margin-top: 20%;
    width: 90%;
    margin-left: 5%;
  }

  .bulle {
    text-decoration: none;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-left: 5%;
  }

  .inspiPerso_titre {
    text-align: center;
    font-weight: 600;
    margin-top: 10%;
  }

  .inspiPerso_paragraphe {
    margin-bottom: 10%;
    margin-top: 5%;
    text-align: center;
  }

  .inspiPerso_btn {
    padding: 1rem 0.925rem 1rem 1.8rem;
    transition: width 0.5s ease-in-out;
    margin-left: 18%;
  }

  .inspiPerso_btn:hover {
    transition: width 0.5s ease-in-out;
    width: 100%;
  }

  .inspiPerso_image {
    width: 90%;
    margin-left: 5%;
    margin-top: 10%;
  }

  .perso__choix {
    display: flex;
    justify-content: center;
    margin-left: 5%;
    flex-wrap: wrap;
    width: 90%;
    margin-top: 5%;
  }

  .perso__choix a {
    text-decoration: none;
  }

  .choix__col {
    margin-right: 5%;
    margin-left: 5%;
  }

  .col__img1,
  .col__img2,
  .col__img3,
  .col__img4,
  .col__img5,
  .col__img6,
  .col__img7,
  .col__img8 {
    width: 5vh;
    height: 5vh;
    border-radius: 100%;
    margin: auto;
  }

  .col__txt {
    font-weight: 200;
    text-align: center;
    margin-top: 10%;
    font-size: 14px;
  }

  .changeEtapes {
    display: flex;
    align-items: center;
    width: 70%;
    justify-content: space-between;
    margin-left: 15%;
    margin-bottom: 10%;
    & .BtnVue {
      padding: 3%;
      border: $bleuVert solid 0.2px;
      border-radius: 10px;
    }
  }

  .etapesFleches {
    margin-top: 15%;
    display: flex;
  }
}
</style>